import { render, staticRenderFns } from "./Navi.vue?vue&type=template&id=3e574853"
import script from "./Navi.vue?vue&type=script&lang=js"
export * from "./Navi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e574853')) {
      api.createRecord('3e574853', component.options)
    } else {
      api.reload('3e574853', component.options)
    }
    module.hot.accept("./Navi.vue?vue&type=template&id=3e574853", function () {
      api.rerender('3e574853', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/Navi.vue"
export default component.exports